const root='/api/index.php?action='
let csrf=''
export const session={user:null}
export async function api(action,{method='GET',body}={}){
 const options={method,credentials:'same-origin',headers:{Accept:'application/json'}}
 if(body!==undefined){options.headers['Content-Type']='application/json';options.headers['X-CSRF-Token']=csrf;options.body=JSON.stringify(body)}
 const [name,...query]=action.split('&');const url=root+encodeURIComponent(name)+(query.length?'&'+query.join('&'):'')
 const response=await fetch(url,options);const data=await response.json().catch(()=>({error:'Invalid server response.'}))
 if(!response.ok)throw new Error(data.error||'Request failed.');if(data.csrf)csrf=data.csrf;if(Object.prototype.hasOwnProperty.call(data,'user'))session.user=data.user;return data
}
export async function boot(){return api('status')}
export function oauthUrl(provider){return `/api/oauth.php?provider=${provider}`}
